import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';

import { GET_EXTENDED_COMPENSATION_BY_TICKET_NUMBERS } from 'store/queries';

const useDelayDurationQuery = ({ ticketNumbers, bookingReference }) => {
  const [getDelayDuration, { data, loading, error }] = useLazyQuery(GET_EXTENDED_COMPENSATION_BY_TICKET_NUMBERS);

  useEffect(
    () => {
      if (bookingReference && ticketNumbers.length) {
        getDelayDuration({
          variables: {
            ticketNumbers,
            bookingReference
          }
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  let delayDurationMins;

  if (data && data.getExtendedCompensationByTicketNumbers.length > 0) {
    delayDurationMins = data.getExtendedCompensationByTicketNumbers[0].delayDurationMins;
  }

  if (error) {
    console.error(`getExtendedCompensationByTicketNumbers ERROR: ${error?.message}`);
  }

  return { delayDurationMins, loading };
};

export default useDelayDurationQuery;
